import { createAsyncAction, createAction } from "typesafe-actions";
import { Station, StationIssue, StationRawData } from "@shared/models";
import {
  GetStationsConnectionsFilter,
  PaginatedResponse,
  StationFilter,
  StationIssueFilter,
  StationViewRawDataFilter,
  WithCallback,
} from "@shared/interfaces";

import { StationActionTypes } from "./constants";
import {
  ActivateDeactivateStationDto,
  ActivateDeactivateStationSuccess,
  CreateStationDto,
  CreateStationSuccess,
  StationConnectionResult,
} from "../interfaces";

export const getStations = createAsyncAction(
  StationActionTypes.GET_STATIONS,
  StationActionTypes.GET_STATIONS_SUCCESS,
  StationActionTypes.GET_STATIONS_FAILURE,
)<StationFilter, PaginatedResponse<Station>, Error>();

export const getStationRawData = createAsyncAction(
  StationActionTypes.GET_STATION_RAW_DATA,
  StationActionTypes.GET_STATION_RAW_DATA_SUCCESS,
  StationActionTypes.GET_STATION_RAW_DATA_FAILURE,
)<{ station_id: number; filter: Omit<StationViewRawDataFilter, "interval"> }, StationRawData[], Error>();

export const getStationsConnections = createAsyncAction(
  StationActionTypes.GET_STATIONS_CONNECTIONS,
  StationActionTypes.GET_STATIONS_CONNECTIONS_SUCCESS,
  StationActionTypes.GET_STATIONS_CONNECTIONS_FAILURE,
)<GetStationsConnectionsFilter, Record<string, StationConnectionResult> | null, Error>();

export const createStation = createAsyncAction(
  StationActionTypes.CREATE_STATION,
  StationActionTypes.CREATE_STATION_SUCCESS,
  StationActionTypes.CREATE_STATION_FAILURE,
)<WithCallback<CreateStationDto>, CreateStationSuccess, Error>();

export const updateStation = createAsyncAction(
  StationActionTypes.UPDATE_STATION,
  StationActionTypes.UPDATE_STATION_SUCCESS,
  StationActionTypes.UPDATE_STATION_FAILURE,
)<WithCallback<CreateStationDto & { id: number }>, CreateStationSuccess, Error>();

export const activateDeactivateStation = createAsyncAction(
  StationActionTypes.ACTIVATE_DEACTIVATE_STATION,
  StationActionTypes.ACTIVATE_DEACTIVATE_STATION_SUCCESS,
  StationActionTypes.ACTIVATE_DEACTIVATE_STATION_FAILURE,
)<WithCallback<ActivateDeactivateStationDto & { id: number }>, ActivateDeactivateStationSuccess, Error>();

export const loadStationsIssues = createAsyncAction(
  StationActionTypes.LOAD_STATIONS_ISSUES,
  StationActionTypes.LOAD_STATIONS_ISSUES_SUCCESS,
  StationActionTypes.LOAD_STATIONS_ISSUES_FAILURE,
)<StationIssueFilter, PaginatedResponse<StationIssue>, Error>();

export const readStationIssue = createAsyncAction(
  StationActionTypes.READ_STATION_ISSUE,
  StationActionTypes.READ_STATION_ISSUE_SUCCESS,
  StationActionTypes.READ_STATION_ISSUE_FAILURE,
)<WithCallback<{ id: number; comment: string }>, StationIssue, Error>();

export const setStationsIssuesFilter = createAction(
  StationActionTypes.SET_STATIONS_ISSUES_FILTER,
)<StationIssueFilter | null>();

export const setFilter = createAction(StationActionTypes.SET_FILTER)<StationFilter | null>();
export const setStationViewRawDataFilter = createAction(
  StationActionTypes.SET_STATION_VIEW_RAW_DATA_FILTER,
)<StationViewRawDataFilter | null>();

export const clearStations = createAction(StationActionTypes.CLEAR_STATIONS)();
